export var OutputFileType;
(function (OutputFileType) {
    OutputFileType["copyRemoteUrl"] = "copyRemoteUrl";
    OutputFileType["text"] = "text";
    OutputFileType["binary"] = "binary";
})(OutputFileType || (OutputFileType = {}));
export var PulsarExecutor;
(function (PulsarExecutor) {
    PulsarExecutor["supernova"] = "supernova";
    PulsarExecutor["local"] = "local";
})(PulsarExecutor || (PulsarExecutor = {}));
const getPulsarBridge = () => {
    const pulsar = globalThis.Pulsar;
    if (!pulsar) {
        throw new Error("Pulsar bridge is not available in this environment");
    }
    return pulsar;
};
export const Pulsar = {
    export(fn) {
        return getPulsarBridge().export(fn);
    },
    exportConfig() {
        return getPulsarBridge().exportConfig();
    },
};
